import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {GenericActionComponent, GenericActionComponentsMethods} from '../generic-action.component';
import {User} from '../../models/user.model';
import {CommonUtils} from '../../utils/common';
import {FormBuilder, Validators} from '@angular/forms';
import {AppStateService} from '../../providers/app-state.service';
import {InputChangeEventDetail, ModalController, ToastController} from '@ionic/angular';
import {TranslateService} from '@ngx-translate/core';
import {UserService} from '../../providers/user.service';
import {Observable} from 'rxjs';
import {Article, ArticlePhotoGalleryImage} from '../../models/article.model';
import {ArticleService} from '../../providers/article.service';
import {PetSpecies} from '../../models/pet-species.model';
import {Client} from '../../models/client.model';
import {ClientsService} from '../../providers/clients.service';
import {Category} from '../../models/category.model';
import {CategoryService} from '../../providers/category.service';
import {GalleryComponent} from '../gallery/gallery.component';
import {VImage} from '../../models/vet-clinic.model';
import {ItemFinderComponent} from '../item-finder/item-finder.component';
import {timeValidator} from '../../utils/form-validators';
import {QuillEditorComponent} from 'ngx-quill';
import {Quill} from 'quill';

@Component({
  selector: 'app-edit-article',
  templateUrl: './edit-article.component.html',
  styleUrls: ['./edit-article.component.scss'],
})
export class EditArticleComponent extends GenericActionComponent implements OnInit, GenericActionComponentsMethods {

  @Input() article: Article;
  @Input() csrfToken: string;

  @Output() objectEditedEmitter = new EventEmitter<Article>();
  @Output() objectAddedEmitter = new EventEmitter<Article>();
  @Output() hasUnsavedChangesEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild('editor') editor: QuillEditorComponent;

  vClientUUID: string;
  clients: Client[];
  editArticleLabel: string;
  keyWords: string[];
  keyWordsItems: string[];
  minAge: number = 0;
  maxAge: number = 0;
  isMale: boolean;
  isFemale: boolean;
  isPublished: boolean;
  publishedSinceDate: string;
  petSpecies: string[];
  tagsSelected: string[];
  tags: string[];

  loadedSpecies: PetSpecies[];
  animalBreeds: string[] = [];
  breedsItems: string[] = [];
  loadedCategories: Category[];
  category: Category;
  categoriesMap: Map<number, Category[]>;
  categoryUUID: string;
  imagesSelected: VImage[];
  photoToPromoteUUID: string;
  visitReminderHook: boolean;
  visitSyncHook: boolean;
  addAnimalHook: boolean;
  userSyncHook: boolean;
  userRegistrationHook: boolean;
  reservationHook: boolean;
  categorySelected: Category;
  changeCategoryMode: boolean = true;
  categoriesLabel: string = 'Kategorie artykułu: (kliknij aby zmienić)';
  startDateValue: string;
  contentImages: VImage[];
  cancelText: 'Anuluj' | 'Wyjdź';
  isPetSterilized: boolean;
  petAgeType: 'MONTHS' | 'YEARS' = 'MONTHS';
  minDateInDate: Date;
  minDate: string;

  editionDisabled: boolean = false;
  clientSelected: Client;
  publishTime: string;
  isArticleTargeted: boolean;
  hasCalendarChange: boolean = false;
  isHTMLToggle: boolean;
  modules = {
    toolbar: {
      container: [
        ['bold', 'italic', 'underline'],        // toggled buttons
        ['image'],
        [{'list': 'ordered'}, {'list': 'bullet'}],
        [{'header': [4, 5, false]}],
      ]
    }
  };
  private textAreaValue: string;
  private textAreaValueToSave: string;
  private quill: Quill;
  private toolbar: any;
  private publishedSinceDateInDate: Date;
  private loggedUser: User;
  private isAdmin: boolean = false;
  private isGeneralAdmin: boolean = false;
  private isArticleRedactor: boolean = false;
  private publishedTimeChanged: boolean;
  mainImage: VImage;
  mainImageUUID: string;
  pictureTxT: string;
  maxDateInDate: Date;
  maxDate: string;
  isGeneralArticleRole: boolean;
  private SITESBI_CLIENT_UUID = 'e7e308bf-6f11-4a09-894f-31477447240d';

  constructor(
    public commonUtils: CommonUtils,
    private formBuilder: FormBuilder,
    private articleService: ArticleService,
    private appStateService: AppStateService,
    private toastController: ToastController,
    private modalController: ModalController,
    private translateService: TranslateService,
    private clientsService: ClientsService,
    private userService: UserService,
    private categoryService: CategoryService
  ) {
    super(commonUtils, appStateService, modalController, translateService,);
  }

  ngOnInit() {
    this.appStateService.updateIsBusySubject(true);
    this.minDateInDate = new Date();
    this.minDateInDate = new Date(this.minDateInDate.getTime() - (this.minDateInDate.getSeconds() * 1000) - this.minDateInDate.getMilliseconds()); // usunięcie sekund i milisekund z daty
    this.minDate = this.commonUtilsLib.dateToYearMonthDayString(this.minDateInDate);
    this.maxDateInDate = this.minDateInDate;
    this.maxDateInDate.setFullYear(this.minDateInDate.getFullYear() + 2);
    this.maxDate = this.commonUtilsLib.dateToYearMonthDayString(this.maxDateInDate);
    this.userService.getUser().subscribe(u => {
      if (u && u.uuid) {
        this.loggedUser = u;
        this.isAdmin = this.filterRoleContains(u, 'admin');
        this.isGeneralAdmin = this.isAdmin && !u.vClientId;
        this.isArticleRedactor = u.roles.split(';').filter(e => e === 'articles-redactor').length === 1;
        this.isGeneralArticleRole = u.roles.split(';').filter(e => e === 'articles').length === 1  && !u.vClientId;

        if (u.vClientUUID) {
          this.vClientUUID = u.vClientUUID;
        }

        this.appStateService.updateIsBusySubject(false);

      }
    });

    if (this.article.vClientUUID) {
      console.log(this.article.vClientUUID);
      console.log(this.SITESBI_CLIENT_UUID);
      this.vClientUUID = this.article.vClientUUID;
      if (this.article.vClientUUID == this.SITESBI_CLIENT_UUID) {
        console.log('asd')
        this.handleTags();
      }
    }

    this.categoryUUID = this.article.categoryUUID;

    if (this.vClientUUID) {
      this.handleCategories();
    }
    this.cancelText = 'Anuluj';


    if (this.article?.uuid) {
      if (this.filterRoleContains(this.loggedUser, 'admin') || this.filterRoleContains(this.loggedUser, 'articles-redactor')) {
        this.cancelText = 'Anuluj';
      } else {
        if (this.article.userUUID === this.loggedUser.uuid) {
          this.cancelText = 'Anuluj';
        } else {
          this.cancelText = 'Wyjdź';
          this.editionDisabled = true;
          this.editArticleLabel = 'Podgląd artykułu';
        }
      }

      this.visitReminderHook = this.article.visitReminderHook;
      this.visitSyncHook = this.article.visitSyncHook;
      this.addAnimalHook = this.article.addAnimalHook;
      this.userSyncHook = this.article.userSyncHook;
      this.userRegistrationHook = this.article.userRegistrationHook;
      this.reservationHook = this.article.reservationHook;
      this.isPetSterilized = this.article.isPetSterilized;
      this.petAgeType = this.article.petAgeType;


      if (this.article.promotedImageUUID) {
        this.photoToPromoteUUID = this.article.promotedImageUUID;
      }

      if (this.article.animalSex === 'M') {
        this.isMale = true;
      }
      if (this.article.animalSex === 'MF') {
        this.isMale = true;
        this.isFemale = true;

      }
      if (this.article.animalSex === 'F') {
        this.isFemale = false;
      }
      if (this.article.isTargeted !== null) {
        this.isArticleTargeted = this.article.isTargeted;
      }

      if (this.article.mainImageUUID && this.article.mainImage) {
        this.mainImage = this.article.mainImage;
        this.mainImageUUID = this.article.mainImageUUID;
        this.pictureTxT =  'Zmień zdjęcie'
      } else {
        this.pictureTxT = 'Dodaj zdjęcie'
      }

      this.minAge = this.article.minAnimalAge;
      this.maxAge = this.article.maxAnimalAge;
      if (this.article.petSpecies) {
        this.petSpecies = JSON.parse(this.article.petSpecies);
      }
      if (this.article.animalBreeds) {
        this.breedsItems = JSON.parse(this.article.animalBreeds);
        this.animalBreeds = JSON.parse(this.article.animalBreeds);
      }

      if (this.article.tagsArray){
        this.tagsSelected = JSON.parse(this.article.tagsArray);
      }

      this.isPublished = this.article.isPublished;
      if (this.article.publishedSinceDate) {
        this.publishedSinceDateInDate = new Date(this.article.publishedSinceDate);
        this.publishedSinceDate = new Date(this.article.publishedSinceDate).toISOString();
        this.publishedSinceDate = this.publishedSinceDate.replace('T', ' ');
        console.log(new Date(this.article.publishedSinceDate).toTimeString());
        this.publishTime = new Date(this.article.publishedSinceDate).toTimeString().substring(0, 5);
        this.startDateValue = this.article.publishedSinceDate.replace(' ', 'T');
      }
    }

    this.appStateService.updateIsBusySubject(true);
    this.articleService.getGlobalPetSpecies().subscribe(ps => {
      this.appStateService.updateIsBusySubject(false);
      this.loadedSpecies = ps;
    }, error => {
      this.appStateService.updateIsBusySubject(false);
    });

    if (this.article?.keyWords) {
      this.keyWords = JSON.parse(this.article.keyWords);
      this.keyWordsItems = JSON.parse(this.article.keyWords);
    } else {
      this.keyWords = [];
      this.keyWordsItems = [];
    }

    if (this.action === 'ADD') {
      this.editArticleLabel = 'Dodaj nowy artykuł';
      this.componentTitle = 'Dodaj artykuł';
      this.actionBtnLabel = 'Dodaj artykuł';
      this.actionQuestion = 'Na pewno chcesz dodać artykuł?';
      this.actionSuccess = 'Artykuł został dodany';
      this.actionError = 'Wystąpił błąd podczas dodawania artykułu';

      if (this.isGeneralAdmin || this.isGeneralArticleRole) {
        this.formGroup = this.formBuilder.group({
          title: ['', Validators.required],
          articleAbstract: ['', Validators.required],
          content: ['', Validators.required],
          keyWords: [''],
          vClientUUID: ['', Validators.required],
          publishTime: ['', [Validators.required, timeValidator]]
        });
      } else {
        this.formGroup = this.formBuilder.group({
          title: ['', Validators.required],
          articleAbstract: ['', Validators.required],
          content: ['', Validators.required],
          keyWords: [''],
          publishTime: ['', [Validators.required, timeValidator]]
        });
      }
      this.contentImages = [];
      this.publishTime = this.getDefaultTimeToPrepaid(this.minDateInDate);
      this.publishedSinceDate = this.minDate.concat(' ', this.publishTime);

    } else {
      this.componentTitle = 'Zmień artykuł';
      this.actionBtnLabel = 'Zmień artykuł';
      this.actionQuestion = 'Na pewno chcesz zmienić artykuł?';
      this.actionSuccess = 'Artykuł został zmieniony';
      this.actionError = 'Wystąpił błąd podczas zmiany artykułu';
      this.editArticleLabel = 'Edytuj artykuł';
      if (!(this.filterRoleContains(this.loggedUser, 'admin') || this.filterRoleContains(this.loggedUser, 'articles-redactor')) && this.article.userUUID !== this.loggedUser.uuid) {
        this.editArticleLabel = 'Podgląd artykułu';
      }

      if (this.isGeneralAdmin || this.isGeneralArticleRole) {
        this.formGroup = this.formBuilder.group({
          title: [this.article.title, Validators.required],
          articleAbstract: [this.article.articleAbstract, Validators.required],
          content: [this.article.content, Validators.required],
          keyWords: [this.article.keyWords],
          vClientUUID: [this.article.vClientUUID, Validators.required],
          publishTime: ['', [Validators.required, timeValidator]]
        });
      } else {
        this.formGroup = this.formBuilder.group({
          title: [this.article.title, Validators.required],
          articleAbstract: [this.article.articleAbstract, Validators.required],
          content: [this.article.content, Validators.required],
          keyWords: [this.article.keyWords],
          publishTime: ['', [Validators.required, timeValidator]]
        });
      }

      this.imagesSelected = this.article.gallery as VImage[];
      if (this.article.contentImages) {
        this.contentImages = this.article.contentImages as VImage[];
      } else {
        this.contentImages = [];
      }
    }


    super.ngOnInit();
  }

  onAction() {
    if (this.formGroup.valid) {
      this.commonUtils.presentYesNoActionSheet('Na pewno chcesz zapisać zmiany?', 'Tak', 'Nie', 'checkmark', 'close', () => {
        const articleObj: Article = this.commonUtils.formGroupValuesToObject<Article>(new Article(), this.formGroup);
        delete articleObj.publishTime;
        articleObj.content = this.textAreaValue;
        console.log(articleObj.content);
        let serviceMethod;

        if (this.isMale !== null || this.isFemale !== null) {
          if (this.isMale && this.isFemale) {
            articleObj.animalSex = 'MF';
          } else {
            if (this.isMale) {
              articleObj.animalSex = 'M';
            } else {
              if(this.isFemale){
                articleObj.animalSex = 'F';
              }
            }
          }
        }

        if (!this.isGeneralAdmin || this.isGeneralArticleRole) {
          articleObj.vClientUUID = this.vClientUUID;
        }

        articleObj.maxAnimalAge = this.maxAge;
        articleObj.minAnimalAge = this.minAge;

        if (this.petSpecies) {
          articleObj.petSpecies = JSON.stringify(this.petSpecies);
        }
        if (this.breedsItems) {
          articleObj.animalBreeds = JSON.stringify(this.breedsItems);
        }

        if (this.tagsSelected) {
          articleObj.tagsArray = JSON.stringify(this.tagsSelected);
        }

        if (this.isPublished !== null) {
          articleObj.isPublished = this.isPublished;
        }
        if (this.publishedSinceDate && (this.hasCalendarChange || this.publishedTimeChanged)) {
          articleObj.publishedSinceDate = this.publishedSinceDate;
        } else {
          articleObj.publishedSinceDate = this.article.publishedSinceDate;
        }

        if (this.isArticleTargeted !== null) {
          articleObj.isTargeted = this.isArticleTargeted;
        }

        articleObj.categoryUUID = this.categoryUUID;

        articleObj.vClientUUID = this.vClientUUID;

        if (this.photoToPromoteUUID) {
          articleObj.promotedImageUUID = this.photoToPromoteUUID;
        }

        if (this.imagesSelected) {
          const galleryImages: ArticlePhotoGalleryImage[] = (this.imagesSelected as VImage[])?.map((vImage) => {
            return new ArticlePhotoGalleryImage(this.vClientUUID, vImage.uuid);
          });
          articleObj.gallery = galleryImages;
        }

        if (this.isPetSterilized) {
          articleObj.isPetSterilized = this.isPetSterilized;
        }

        if (this.petAgeType) {
          articleObj.petAgeType = this.petAgeType;
        }

        if (this.mainImageUUID) {
          articleObj.mainImageUUID = this.mainImageUUID;
        }

        articleObj.visitReminderHook = this.visitReminderHook;
        articleObj.visitSyncHook = this.visitSyncHook;
        articleObj.addAnimalHook = this.addAnimalHook;
        articleObj.userSyncHook = this.userSyncHook;
        articleObj.userRegistrationHook = this.userRegistrationHook;
        articleObj.reservationHook = this.reservationHook;

        if (this.action === 'EDIT') {
          articleObj.uuid = this.article.uuid;
          serviceMethod = this.articleService.updateArticle(articleObj);
        } else {
          serviceMethod = this.articleService.addArticle(articleObj);
        }

        this.handleActionMethodForAddingArticle(serviceMethod, this.objectAddedEmitter, this.objectEditedEmitter);

      }, () => {
      });
    }
  }

  private handleActionMethodForAddingArticle(serviceMethod: Observable<Article>, objectAddedEmitter: EventEmitter<Article>, objectEditedEmitter: EventEmitter<Article>) {
    this.appStateService.updateIsBusySubject(true);

    serviceMethod.subscribe((obj: Article) => {
        this.appStateService.updateIsBusySubject(false);
        if (obj && obj.uuid) {
          this.commonUtils.presentInfoToast(this.actionSuccess).then(res => {
            if (this.action === 'ADD') {
              objectAddedEmitter.emit(obj);
            } else {
              objectEditedEmitter.emit(obj);
            }
            this.hasUnsavedChanges = false;
          });
        }
      },
      error => {
        this.appStateService.updateIsBusySubject(false);
        this.commonUtils.presentAlertToast(this.actionError);
      });
  }

  filterRoleContains(user: User, role: string) {
    return user?.roles?.split(';').filter(e => e === role).length === 1;
  }

  onSelectClient(vClientUUID: string) {
    this.vClientUUID = vClientUUID;
    this.handleCategories();
    this.formGroup.controls.vClientUUID.setValue(this.vClientUUID);
  }

  addNewTags() {
    this.keyWordsItems.push('');
    this.keyWords.push('');
  }

  removeKeyWord(idx) {
    if (this.keyWordsItems[idx] !== undefined) {
      this.keyWordsItems.splice(idx, 1);
      if (this.keyWordsItems.length === 0) {
        this.keyWords = [];
      } else {
        this.keyWords = [...this.keyWordsItems];
      }
      this.formGroup.get('keyWords').setValue(JSON.stringify(this.keyWordsItems));
      this.markUnsavedChanges();
    }
  }

  markUnsavedChanges() {
    if (!this.hasUnsavedChanges) {
      this.hasUnsavedChangesEmitter.emit(true);
      super.markUnsavedChanges();
    }
  }

  changeValue(idx: any, event: CustomEvent<InputChangeEventDetail>) {
    if (this.keyWordsItems[idx] !== undefined) {
      this.keyWordsItems[idx] = event.detail.value;
      this.formGroup.get('keyWords').setValue(JSON.stringify(this.keyWordsItems));
      this.markUnsavedChanges();
    }
  }

  changeRange($event) {
    this.maxAge = $event.detail.value.upper;
    this.minAge = $event.detail.value.lower;
  }

  changeCalendarValue($event) {
    console.log($event);
    this.hasCalendarChange = true;
    const dateSplited = $event.detail.value.split('T');
    this.publishedSinceDate = dateSplited[0].concat(' ', this.publishTime);
  }

  getDefaultTimeToPrepaid(date: Date) {
    const hour: number = date.getHours();
    const minute: number = date.getMinutes();
    let hourString: string = hour.toString();
    let minuteString: string = minute.toString();

    if (hour < 10) {
      hourString = '0'.concat(hourString);
    }
    if (minute < 10) {
      minuteString = '0'.concat(minuteString);
    }
    return hourString.concat(':', minuteString);
  }


  onSelectSpecies($event) {
    this.petSpecies = $event.detail.value;
  }

  onSelectTags($event) {
    this.tagsSelected = $event.detail.value;
  }

  changeBreedValue(idx: any, $event) {
    if (this.breedsItems[idx] !== undefined) {
      this.breedsItems[idx] = $event.detail.value;
      this.markUnsavedChanges();
    }
  }

  removeBreed(idx: number) {
    if (this.breedsItems[idx] !== undefined) {
      this.breedsItems.splice(idx, 1);
      if (this.breedsItems.length === 0) {
        this.animalBreeds = [];
      } else {
        this.animalBreeds = [...this.breedsItems];
      }
      this.markUnsavedChanges();
    }

  }

  addBreeds() {
    this.breedsItems.push('');
    this.animalBreeds.push('');
  }

  private handleCategories() {
    this.categoryService.getCategories(this.vClientUUID).subscribe(e => {
      if (e) {
        let keys = Object.keys(e.categories).map(s => {
          return Number.parseInt(s);
        });
        const convMap = new Map();
        const convArr = [];
        keys.forEach(key => {
          convMap.set(key, e.categories[key]);
          convArr.push(...e.categories[key]);
        });

        this.categoriesMap = convMap;
        this.loadedCategories = convArr;
        if (this.categoryUUID) {
          this.categorySelected = this.loadedCategories.filter(e => e.uuid === this.categoryUUID)[0];
          this.changeCategoryMode = false;
        }
      }
    })

  }

  async openGallery() {
    const modal = await this.modalController.create({
      component: GalleryComponent,
      componentProps: {
        'vClientUUID': this.vClientUUID,
        'picturesSelected': this.imagesSelected,
        'type': 'articles'
      }
    });

    modal.onDidDismiss().then((dismissData) => {
      if (dismissData && dismissData?.data) {
        console.log(dismissData.data)
        this.article.gallery = dismissData?.data;
        this.imagesSelected = dismissData?.data;
      }
    });

    return await modal.present();
  }

  getUrl(picture: VImage) {
    return this.commonUtils.getCloudVImageUrlPath(picture.imageFolder, picture.mFolderUUID, '640', picture);
  }

  async addPhotoToArticle() {
    const range = this.quill.getSelection();
    const modal = await this.modalController.create({
      component: GalleryComponent,
      componentProps: {
        'vClientUUID': this.vClientUUID,
        'picturesSelected': null,
        'type': 'add-article-picture',
        'isAdmin': this.isAdmin
      }
    });

    modal.onDidDismiss().then((dismissData) => {
      if (dismissData && dismissData?.data) {
        this.contentImages.push(dismissData.data);
        this.hasUnsavedChanges = true;
        const tag = `<img id="vetineo-${dismissData.data.uuid}" src="${this.getUrl(dismissData.data)}">`;
        if (range.index) {
          this.quill.clipboard.dangerouslyPasteHTML(range.index, tag);
        } else {
          (this.quill.root as HTMLDivElement).innerHTML = (this.quill.root as HTMLDivElement).innerHTML + tag;
        }
      }
    });

    return await modal.present();
  }

  onEmittedCategory(cat: Category) {
    this.categorySelected = cat;
    this.categoryUUID = cat.uuid;
    this.changeCategoryMode = false;
    this.categoriesLabel = 'Kategorie artykułu: (kliknij aby zmienić)';
  }


  canEdit() {
    if (this.loggedUser) {
      if (this.article?.uuid) {
        if (this.filterRoleContains(this.loggedUser, 'admin') || this.filterRoleContains(this.loggedUser, 'articles-redactor')) {
          return true;
        } else {
          return this.article.userUUID === this.loggedUser.uuid;
        }
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  canPublish() {
    if (this.loggedUser) {
      return this.filterRoleContains(this.loggedUser, 'admin') || this.filterRoleContains(this.loggedUser, 'articles-redactor')
    } else {
      return false;
    }
  }

  onSelectAgeType($event) {
    this.petAgeType = $event.detail.value;
  }

  checkIfTimeIsValid() {
    if (this.formGroup.controls.publishTime.valid) {
      this.publishedTimeChanged = true;
      let usedSplit: string[];
      const splitWithSpacebar = this.publishedSinceDate.split(' ');
      if (splitWithSpacebar.length > 1) {
        usedSplit = splitWithSpacebar;
      } else {
        const splitWithT = this.publishedSinceDate.split('T');
        if (splitWithT.length > 1) {
          usedSplit = splitWithT;
        }
      }
      if (usedSplit) {
        const tempPublishedSinceDate = usedSplit[0].concat(' ', this.publishTime);
        if (new Date(tempPublishedSinceDate) < this.minDateInDate) {
          this.formGroup.controls.publishTime.setErrors({time: true});
        } else {
          this.publishedSinceDate = tempPublishedSinceDate;
        }
      }
    }
  }

  async onSearchClients() {
    const modal = await this.modalController.create({
      component: ItemFinderComponent,
      componentProps: {
        title: 'Wyszukaj klienta',
        itemType: 'clients',
        nameToFind: this.clientSelected ? this.clientSelected.name : '',
        partnersIncluded: true
      }
    });

    modal.onWillDismiss().then(data => {
      if (data && data.data) {
        this.clientSelected = data.data;
        if (this.clientSelected.uuid === this.SITESBI_CLIENT_UUID) {
          this.handleTags();
        }
        this.onSelectClient(this.clientSelected.uuid);
      }
    });

    return await modal.present();

  }

  cancelEdition() {
    if (this.editionDisabled) {
      this.hasUnsavedChanges = false;
      this.actionCanceledEmitter.emit(true);
    } else {
      super.onCancelAction();
    }
  }

  changedEditor($event: any) {
    if ($event.html) {
      this.textAreaValue = $event.html.replace(new RegExp(/<p><br[\/]?><[\/]?p>/g), '<br>');
      const lines = this.textAreaValue.split('</p>');
      this.textAreaValue = lines.join('</p>\n');
      this.textAreaValue = this.textAreaValue.replace(new RegExp('\n$'), '');
      this.textAreaValueToSave = this.textAreaValue;

    }
    if ($event.event === 'text-change') {
      this.markUnsavedChanges();
      this.formGroup.controls.content.markAsTouched();
    }
  }

  onHTMLToggle($event) {
    this.isHTMLToggle = $event.detail.checked;
  }

  textAreaChange($event) {
    this.textAreaValue = $event.detail.value;
  }

  onSaveHTML() {
    this.formGroup.controls.content.setValue(this.textAreaValue);
  }

  onEditorCreated() {
    this.quill = this.editor.quillEditor;
    this.toolbar = this.quill.getModule('toolbar');
    this.toolbar.addHandler('image', this.addPhotoToArticle.bind(this));
    if (this.action === 'EDIT') {
      this.textAreaValue = this.article.content;
      this.textAreaValueToSave = this.textAreaValue;
    }
  }

  getQuillStyle() {
    if (!this.editionDisabled && !this.article.isPublished) {
      return {height: '500px', 'font-size': '16px'};
    } else {
      return {height: 'auto', 'font-size': '16px'};
    }
  }

  getContentLabel() {
    if (this.article.isPublished) {
      return 'Opublikowana treść';
    }
    return 'Treść';
  }

  async setNewMainImage(article: Article) {
    const modal = await this.modalController.create({
      component: GalleryComponent,
      componentProps: {
        'vClientUUID': article.vClientUUID,
        'picturesSelected': null,
        'type': 'main',
        'isAdmin': this.isAdmin
      }
    });

    modal.onDidDismiss().then((dismissData) => {
      if (dismissData && dismissData?.data && dismissData?.data?.uuid) {
        this.mainImageUUID = dismissData?.data?.uuid;
        this.mainImage = dismissData?.data;
        this.pictureTxT =  'Zmień zdjęcie'
      }
    });

    return await modal.present();
  }

  private handleTags() {
    this.tags = this.commonUtils.getTags();
    console.log(this.tags);
    console.log(this.tagsSelected);
  }
}



